import { useTranslation } from 'react-i18next'

type UseTooltipTitleProps = {
  hasOptJob: boolean
  hasPublishableWip: boolean
  isOptimizing: boolean
  isPublishing: boolean
}

export default function useTooltipTitle({
  hasOptJob,
  hasPublishableWip,
  isOptimizing,
  isPublishing,
}: UseTooltipTitleProps) {
  const { t } = useTranslation()

  if (!hasOptJob) {
    return t('There is no production plan to publish')
  }

  if (isOptimizing) {
    return t('Optimization in progress')
  }

  if (isPublishing) {
    return t('Publishing in progress')
  }

  if (!hasPublishableWip) {
    return t('Production plan is up-to-date')
  }

  return ''
}
